import * as angular from "angular";

angular
  .module('bringoz.admin.shippers')
  .constant('Shippers_PN', {
    database: 'shippers',
    isBranchEntity: false,
  });
